export class CommonConstants {
    public static TOTAL_CUSTOMER_SHIFT_MORE_THAN_SEVENTY = 70;
    public static IS_GUARD_LATE_FALSE = 0;
    public static IS_GUARD_LATE_TRUE = 1;
    public static PUNCTIONALITY_INITIAL = 0
    public static PUNCTIONALITY_POOR = 50
    public static PUNCTIONALITY_GOOD = 80;
    public static PUNCTIONALITY_EXCELLENT = 100 

    // worker shift statuses
    public static CUSTOMER_DISAPPROVE_HOURS = 302;
}
